import { render, staticRenderFns } from "./ManagePage.vue?vue&type=template&id=52bc09e3&scoped=true"
import script from "./ManagePage.vue?vue&type=script&lang=js"
export * from "./ManagePage.vue?vue&type=script&lang=js"
import style0 from "./ManagePage.vue?vue&type=style&index=0&id=52bc09e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bc09e3",
  null
  
)

export default component.exports